/**
=========================================================
* Scroll to Top Component
=========================================================
*/

import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";

function ScrollToTop() {
  const [showButton, setShowButton] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      // Show button when user scrolls down more than 300px
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    // Check initial scroll position on mount
    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!showButton) {
    return null;
  }

  return (
    <MDBox
      onClick={scrollToTop}
      sx={{
        position: "fixed",
        bottom: { xs: "20px", sm: "30px" },
        right: { xs: "20px", sm: "30px" },
        width: { xs: "38px", sm: "42px" },
        height: { xs: "38px", sm: "42px" },
        borderRadius: { xs: "12px", sm: "14px" },
        background: theme.palette.mode === "dark" 
          ? "linear-gradient(135deg, rgba(102, 126, 234, 0.65) 0%, rgba(118, 75, 162, 0.65) 100%)"
          : "linear-gradient(135deg, rgba(102, 126, 234, 0.65) 0%, rgba(118, 75, 162, 0.65) 100%)",
        backdropFilter: "blur(10px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
        zIndex: 1000,
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 6px 16px rgba(102, 126, 234, 0.5)",
          background: theme.palette.mode === "dark"
            ? "linear-gradient(135deg, rgba(118, 75, 162, 0.8) 0%, rgba(102, 126, 234, 0.8) 100%)"
            : "linear-gradient(135deg, rgba(118, 75, 162, 0.8) 0%, rgba(102, 126, 234, 0.8) 100%)",
        },
        "&:active": {
          transform: "translateY(-2px)",
        },
      }}
    >
      <Icon
        sx={{
          color: "white",
          fontSize: { xs: "2rem", sm: "2.25rem" },
          fontWeight: "bold",
        }}
      >
        keyboard_arrow_up
      </Icon>
    </MDBox>
  );
}

export default ScrollToTop;
